import { useEffect, useState } from 'react'
import { Button } from '../../components/button'
import { ColorPickerButton } from '../../components/buttonSelectionColor'
import { UploadFile } from '../../components/uploadFile'
import { useUploadFile } from '../../hooks/uploadFile'
import { useUploadLogoMutation } from '../../store/modules/company/api'
import './styles.scss'
import { Loader } from '../../components/loader'
import { KEY_NAMES_COLORS } from './constants'
import { UploadLogoEnum } from '../../store/modules/company/types'
import { useSteps } from '../../hooks/setup/useSteps'
import { useLocalStorage } from '../../hooks/useLocalStorage'
import { WarningEmptyUploadModal } from '../../components/warningEmptyUploadModal'

export const SystemConfig = () => {
  const { setItem, getItem } = useLocalStorage()
  const { file, cleanState } = useUploadFile()
  const [handlerUploadLogo, { isLoading }] = useUploadLogoMutation()
  const { nextStep } = useSteps()
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [dataColors, setdataColors] = useState<Record<string, string>>({})

  useEffect(() => {
    if (!file) return

    const loadUploadLogo = async () => {
      const tmpFile = getItem('file')

      if (tmpFile === file) return

      const logo = new FormData()

      logo.append('logo', file)
      handlerUploadLogo({ data: logo })
        .unwrap()
        .then((response) => {
          setItem('file', file)
          setdataColors(response)
        })
    }

    loadUploadLogo()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file])

  useEffect(() => {
    const colors = getItem('draftColorsLogo')

    if (!colors) return

    setdataColors(colors as Record<string, string>)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const renderColors = () => {
    if (isLoading) {
      return (
        <div className="content-load">
          <Loader />
        </div>
      )
    }

    if (!Object.keys(dataColors).length) return null

    return Object.entries(dataColors!)
      .filter(([, value]) => !!value)
      .map(([key, value], index) => {
        return (
          <ColorPickerButton
            key={index}
            disabled
            id={key}
            color={value}
            titleDefaultSelectColor={KEY_NAMES_COLORS[key as UploadLogoEnum]}
          />
        )
      })
  }

  const handlerOnSubmit = async () => {
    if (!Object.keys(dataColors).length) {
      setIsOpenModal(true)
      return
    }

    cleanState()
    setItem('draftColorsLogo', dataColors)
    await nextStep()
  }

  const handlerOnConfirmNextStepWithoutFile = async () => {
    await nextStep()
  }

  return (
    <div className="container-main-system-config">
      <WarningEmptyUploadModal
        isOpen={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        onConfirm={handlerOnConfirmNextStepWithoutFile}
      />

      <div className="content-title">
        <strong>Configuração do Sistema</strong>

        <p>Personalize o sistema com a cara da sua empresa.</p>
      </div>

      <div className="container-enter-data">
        <div className="content-upload">
          <UploadFile />

          {dataColors && (
            <div className="content-info-upload">
              <strong>Selecione as cores principais da sua marca.</strong>
              <p>
                O seu tema será personalizado a partir das cores que você
                selecionar.
              </p>
            </div>
          )}
        </div>

        <div className="content-color-suggestions">{renderColors()}</div>

        <div className="content-btn-submit">
          <Button
            onClick={handlerOnSubmit}
            type="button"
            className="content-btn-submit"
          >
            Avançar
          </Button>
        </div>
      </div>
    </div>
  )
}
